export const SUBPROFILE_RELATIONSHIP_OPTIONS = [
  { value: 'sohn', label: 'Sohn' },
  { value: 'tochter', label: 'Tochter' },
  { value: 'enkel', label: 'Enkel' },
  { value: 'enkelin', label: 'Enkelin' },
  { value: 'partner', label: 'Partner' },
  { value: 'partnerin', label: 'Partnerin' },
  { value: 'mutter', label: 'Mutter' },
  { value: 'vater', label: 'Vater' },
  { value: 'geschwister', label: 'Geschwister' },
  { value: 'sonstiges', label: 'Sonstiges' },
] as const;

const NUR_MAENNLICH = new Set<string>(['sohn', 'enkel', 'partner', 'vater']);
const NUR_WEIBLICH = new Set<string>(['tochter', 'enkelin', 'partnerin', 'mutter']);

/** Beziehungen passend zur Anrede (T-0056); Divers, Firma und ohne Anrede: alle. */
export function relationshipOptionsFor(salutation?: string | null) {
  if (salutation === 'Herr') return SUBPROFILE_RELATIONSHIP_OPTIONS.filter((o) => !NUR_WEIBLICH.has(o.value));
  if (salutation === 'Frau') return SUBPROFILE_RELATIONSHIP_OPTIONS.filter((o) => !NUR_MAENNLICH.has(o.value));
  return [...SUBPROFILE_RELATIONSHIP_OPTIONS];
}

export function relationshipLabel(value?: string | null): string | null {
  const normalized = String(value || '').trim().toLowerCase();
  if (!normalized) return null;
  const option = SUBPROFILE_RELATIONSHIP_OPTIONS.find((it) => it.value === normalized);
  return option?.label || null;
}

export function relationshipText(
  relationshipType?: string | null,
  parentName?: string | null
): string | null {
  const label = relationshipLabel(relationshipType);
  const name = String(parentName || '').trim();
  if (!label || !name) return null;
  return `${label} von ${name}`;
}

/** Was ein Profil für die Anzeige der Beziehung mitbringt. */
type ProfilMitBeziehung = {
  index: number;
  relationshipType?: string;
  relationshipLabel?: string;
  birthDate?: string;
};

/** „10 Jahre, 3 Monate“ — leer ohne gültiges Geburtsdatum. */
export function alterText(geburtsdatum?: string, heute: Date = new Date()): string {
  if (!geburtsdatum) return '';
  const geboren = new Date(geburtsdatum);
  if (Number.isNaN(geboren.getTime())) return '';
  let monate = (heute.getFullYear() - geboren.getFullYear()) * 12 + (heute.getMonth() - geboren.getMonth());
  if (heute.getDate() < geboren.getDate()) monate -= 1;
  if (monate < 0) return '';
  const jahre = Math.floor(monate / 12);
  const rest = monate % 12;
  const teile = [`${jahre} ${jahre === 1 ? 'Jahr' : 'Jahre'}`];
  if (rest > 0) teile.push(`${rest} ${rest === 1 ? 'Monat' : 'Monate'}`);
  return teile.join(', ');
}

/** Wer das Profil für den Kunden ist: „Eigenes Profil“ oder „Tochter (10 Jahre, 3 Monate)“ (T-0156). */
export function beziehungsText(sp: ProfilMitBeziehung): string {
  if (sp.index === 1) return 'Eigenes Profil';
  const beziehung = relationshipLabel(sp.relationshipType) || sp.relationshipLabel || 'Zugeordnete Person';
  const alter = alterText(sp.birthDate);
  return alter ? `${beziehung} (${alter})` : beziehung;
}

